let currentPage = 1;

const loadMoreButton = document.getElementById('load-more');
const productGrid = document.querySelector('[id^="product-grid"]');
const loadMoreContainer = document.getElementById('load-more-container');

const totalPagesElement = document.querySelector('.pagination');

const totalPages = totalPagesElement
  ? parseInt(totalPagesElement.dataset.totalPages)
  : 1;

if (loadMoreButton && productGrid && loadMoreContainer) {

  const totalProducts = parseInt(
    loadMoreContainer.dataset.totalProducts
  );

  const pageSize = parseInt(
    loadMoreContainer.dataset.pageSize
  );

  const countElement = document.getElementById('load-more-count');
  const progressBar = document.getElementById('load-more-progress-bar');


  /* -----------------------------------------
     COUNT REAL PRODUCTS
     ----------------------------------------- */

  function getDisplayedProducts() {

    return productGrid.querySelectorAll(
      'li[data-product-handle]'
    ).length;

  }


  /* -----------------------------------------
     UPDATE COUNTER + PROGRESS BAR
     ----------------------------------------- */

  function updateProgress() {

    const displayedProducts = Math.min(
      getDisplayedProducts(),
      totalProducts
    );

    const percentage =
      (displayedProducts / totalProducts) * 100;


    if (countElement) {

      countElement.textContent =
        `You have viewed ${displayedProducts} of ${totalProducts} items.`;

    }


    if (progressBar) {

      progressBar.style.width =
        `${percentage}%`;

    }


    /* -----------------------------------------
       EVERYTHING HAS BEEN LOADED
       ----------------------------------------- */

    if (
      displayedProducts >= totalProducts ||
      currentPage >= totalPages
    ) {

      loadMoreContainer.style.display = 'none';

    }

  }


  /* Initial state */

  updateProgress();


  /* -----------------------------------------
     LOAD MORE
     ----------------------------------------- */

  loadMoreButton.addEventListener(
    'click',
    function () {

      loadMoreButton.disabled = true;

      loadMoreButton.textContent = 'Loading...';

      currentPage += 1;


      fetch(
        `${window.location.pathname}?page=${currentPage}&section_id=${productGrid.dataset.id}`
      )

        .then(response => response.text())

        .then(html => {

          const parser = new DOMParser();

          const doc =
            parser.parseFromString(
              html,
              'text/html'
            );


          const newGrid =
            doc.querySelector(
              '[id^="product-grid"]'
            );


          if (!newGrid) {

            console.warn(
              'New product grid not found'
            );

            loadMoreButton.disabled = false;

            loadMoreButton.textContent =
              'Load More';

            return;

          }


          /* -----------------------------------------
             ONLY USE PRODUCT ITEMS FOR DUPLICATE CHECK
             ----------------------------------------- */

          const newItems =
            newGrid.querySelectorAll(
              'li[data-product-handle]'
            );


          const existingHandles =
            Array.from(
              productGrid.querySelectorAll(
                'li[data-product-handle]'
              )
            ).map(
              item =>
                item.getAttribute(
                  'data-product-handle'
                )
            );


          newItems.forEach(item => {

            const handle =
              item.getAttribute(
                'data-product-handle'
              );


            if (
              !existingHandles.includes(handle)
            ) {

              productGrid.appendChild(item);

            }

          });


          /* -----------------------------------------
             UPDATE UI
             ----------------------------------------- */

          updateProgress();


          /* If there are still products */

          if (
            getDisplayedProducts() <
              totalProducts &&
            currentPage < totalPages
          ) {

            loadMoreButton.disabled = false;

            loadMoreButton.textContent =
              'Load More';

          }

        })

        .catch(error => {

          console.error(
            'Load More error:',
            error
          );


          loadMoreButton.disabled = false;

          loadMoreButton.textContent =
            'Load More';

        });

    }
  );

}